import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface TipoMantenimiento {
  id?: number;
  descripcion: string;
  estado: number;
}

@Injectable({
  providedIn: 'root'
})
export class TipoMantenimientoService {
  private apiUrl =  `${environment.apiUrl}/api/tipo_Mantenimiento`; 
  //private apiUrl = 'http://localhost:3000/api/tipo_Mantenimiento';

  constructor(private http: HttpClient) {}

  // Obtener todos los tipos
  getTipos(): Observable<TipoMantenimiento[]> {
    return this.http.get<TipoMantenimiento[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener un tipo por ID
  getTipoById(id: number): Observable<TipoMantenimiento> {
    return this.http.get<TipoMantenimiento>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo tipo
  createTipo(data: TipoMantenimiento): Observable<any> {
    return this.http.post(this.apiUrl, data, { withCredentials: true });
  }

  // Actualizar tipo por ID
  updateTipo(id: number, data: TipoMantenimiento): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data, { withCredentials: true });
  }

  // Inactivar tipo por ID
  inactivarTipo(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Obtener tipos por estado
  getTiposByEstado(estado: number): Observable<TipoMantenimiento[]> {
    return this.http.get<TipoMantenimiento[]>(`${this.apiUrl}/estado/${estado}`, { withCredentials: true });
  }
}
